module.exports = __webpack_public_path__ + "img/img6.262dac30.png";